/** Лёгкая отдача при переключении вкладок. Динамический ввоз; в браузере — пустышка. */
export async function tapLight(): Promise<void> {
  try {
    const { Capacitor } = await import('@capacitor/core');
    if (!Capacitor.isNativePlatform()) return;
    const { Haptics, ImpactStyle } = await import('@capacitor/haptics');
    await Haptics.impact({ style: ImpactStyle.Light });
  } catch { /* нет плагина или устройство без вибро */ }
}
